import { render, staticRenderFns } from "./TestingApproval.vue?vue&type=template&id=704869e8"
import script from "./TestingApproval.vue?vue&type=script&lang=ts"
export * from "./TestingApproval.vue?vue&type=script&lang=ts"
import style0 from "./TestingApproval.vue?vue&type=style&index=0&id=704869e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports